
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import SwiperBtn from './SwiperBtn.vue'
import lodash from 'lodash'

@Component({
  components: {
    NewSwiper,
    SwiperBtn
  }
})
export default class StationeryBag extends Vue {
  @Prop() dataSource: Array<{
    titleImg: string
    list: Array<{
      cover: string
      name: string
    }>
    modalInfo: {
      banner: Array<{
        cover: string
        jump_url: string
      }>
      list: Array<{
        cover: string
        jump_url: string
        name: string
      }>
    }
  }>

  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  activeIndex: number = 0
  isThree: boolean = false // 是否三列

  get dataList() {
    // 防止数量过长
    const limit_l = this.isThree ? 3 : 4
    const dataSource = this.dataSource.map(item => {
      return {
        ...item,
        list: item.list.length > limit_l ? item.list.slice(0, 3) : item.list
      }
    })

    return lodash.chunk(dataSource, this.isThree ? 3 : 2)
  }

  @Emit('show-qrcode-pop')
  handleShowQrcode(item) {
    return {
      item,
      type: 'buy'
    }
  }

  // 拉起弹窗
  @Emit('open-modal')
  handleOpen(info) {
    return info
  }
  // 上一页
  prev() {
    if (!this.swiper) return
    this.swiper.handlePrev()
  }
  // 下一页
  next() {
    if (!this.swiper) return
    this.swiper.handleNext()
  }
  // 轮播切换事件
  handleChange(index: number) {
    if (this.activeIndex === index) return

    this.activeIndex = index
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
